import { render, staticRenderFns } from "./pageMain.vue?vue&type=template&id=49af1a34&scoped=true"
import script from "./pageMain.vue?vue&type=script&lang=js"
export * from "./pageMain.vue?vue&type=script&lang=js"
import style0 from "./pageMain.vue?vue&type=style&index=0&id=49af1a34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49af1a34",
  null
  
)

export default component.exports